/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var registry = {};
/**
 * Register the page view callback that will be called on React route changes
 * and during IEG page navigation.
 * @param {function} callback The callback to be invoked to track page views.
 */

export function registerPageViewCallback(callback) {
  registry.pageView = callback;
}
/**
 * Invokes the registered pageView callback (if any) with the appropriate props.
 * For IEG pages, they will be set as follows:
 * - pageType will be set to 'IEG'
 * - scriptID will contain the IEG script ID
 * - pageID will contain the current IEG page ID
 * For non-IEG pages, they will be set as follows:
 * - title will be set to the document title
 * - location will be set to the location href
 * - path will be set to the path name
 * @param {Object} props The properties.
 */

export function pageView(props) {
  if (registry.pageView) {
    registry.pageView(props);
  }
}